module.exports = __webpack_public_path__ + "img/8_64.2f229557.png";